// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.direct-invite[data-v-84aeb762] {\n  margin-right: -15px;\n  margin-left: -15px;\n  padding: 0 15px 15px;\n  background: inherit;\n  color: inherit;\n}\n.direct-invite__important[data-v-84aeb762] {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
